import { getAppInfo } from '@/api/app/app'

export default {
  state: {
    info: {},
    cache: {},
  },
  getters: {
    isAdminApp(state) {
      return state.info?.ownerType === '1'
    },
    cachedApp: state => id => {
      return state.cache[id]
    }
  },
  mutations: {
    setInfo(state, data) {
      state.info = { ...data }
    },
    setCacheApp(state, app) {
      const appId = app?.id ?? null
      if (!appId) {
        return
      }
      const cache = { ...state.cache }
      cache[appId] = app
      state.cache = cache
    },
  },
  actions: {
    getAppInfo({commit}, data) {
      return getAppInfo(data).then(res => {
        if (res.code === 0) {
          commit('setInfo', res.data)
          commit('setCacheApp', res.data)
        }
        return res
      })
    },
    getAppInfoById({commit, state}, data) {
      const appId = data.id
      if (!appId) {
        return new Promise(resolve => {
          resolve()
        })
      }
      const app = this.cachedApp(appId)
      if (app) {
        return new Promise(resolve => {
          resolve(app)
          return app
        }) 
      }
      return getAppInfo(data).then(res => {
        if (res.code === 0) {
          commit('setCacheApp', res.data)
        }
        return res
      })
    }
  }
}